<template>
  <div class="container">
    <div class="scrollable">
      <div class="content" v-if="!brandContent">
        <div class="title">{{ content.title }}</div>
        <div class="brands-container">
          <div class="brand brand-img" v-for="brand in brands" :key="brand">
            <router-link
              tag="div"
              class="brand-img"
              :to="{ path: './' + $route.params.content, query:{ n: brand } }"
            >
              <img :src="'../../assets/img/brands/' + brand + '.png'" />
            </router-link>
            <!-- <div class="brand-name bold-brand">{{ brand }}</div> -->
          </div>
        </div>
        <div class="brands-container">
          <div
            class="brand bold-brand"
            v-for="brand in content.brands"
            :key="brand"
          >{{ brand }}</div>
        </div>
      </div>
      <div class="content" v-else>
        <div class="title">{{ brandName }}</div>
        <div class="brand-content"> {{ brandContent }} </div>

      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import LovalFooter from '../LovalFooter'
import axios from 'axios'
export default {
  components: {
    LovalFooter
  },
  props: ['content', 'links', 'brandName'],
  data () {
    return {
      brands: [],
      brandContent: ''
    }
  },
  mounted () {
    this.getBrands()
  },
  watch: {
    brandName: function () {
      let key = this.$route.query.n
      if (key === undefined) {
        this.brandContent = ''
      } else {
        key = key.toLowerCase()
        this.brandContent = this.content.details[key]
      }
    }
  },
  methods: {
    getBrands () {
      let url = '../../assets/img/brands/dir.php'
      axios.get(url).then(result => {
        if (Array.isArray(result.data)) {
          this.brands = result.data
        } else {
          this.brands = ['Siemens', 'Festo']
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");
.scrollable {
  height: calc(100% - var(--loval-footer-height));
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}
.brands-container {
  display: flex;
  flex-wrap: wrap;
}
.brand {
  // border: 1px solid lightsteelblue;
  padding: 2px 5px;
  display: flex;
  align-items: center;
  width: 50%;
  box-sizing: border-box;
}
.brand.brand-img{
  display: flex;
  flex-direction: column;
  justify-content: center;
  & img{
    // cursor:pointer;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
.brand-name{
  padding: 5px 0;
}
.bold-brand {
  font-weight: bold;
}
@media only screen and (min-width: 576px) {
  .brand {
    width: calc(100% / 3);
  }
}
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
}
@media only screen and (min-width: 992px) {
  .brand {
    width: calc(100% / 4);
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: white;
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
}
</style>
